import { useSession } from "next-auth/react";
import { useEffect } from "react";
import axios from "axios";
import { useUI } from "../context/UIContext";

export const useStartVerifyEmail = () => {
  const { data: session, status }: { data: any; status: string } = useSession();
  const { state: uiState, dispatch } = useUI();

  useEffect(() => {
    if (
      status === "authenticated" &&
      session.accessToken &&
      !uiState.isEmailVerified
    ) {
      // Already confirmed per the `email` scope in the login response: no
      // GraphQL call needed.
      if (session.emailConfirmed === true) {
        dispatch({
          type: "confirmEmail",
        });
        window.localStorage.setItem("verify_email_flow", "false");
        return;
      }
      window.localStorage.setItem("verify_email_flow", "true");
      const fetchData = async () => {
        const { data } = await axios.get("/api/check-email", {
          params: {
            access_token: session.accessToken,
          },
        });
        if (data?.data?.me?.profile?.emailConfirmed) {
          dispatch({
            type: "confirmEmail",
          });
          window.localStorage.setItem("verify_email_flow", "false");
        }
        if (!data?.data?.me?.profile?.emailConfirmed) {
          dispatch({
            type: "toggleJoinFlowInfoModal",
            payload: { isOpen: true, modalType: "email" },
          });
        }
      };
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, uiState.isEmailVerified]);
};
